import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const cancelPickup = {
  name: "cancelPickup" as const,
  input: z.object({ returnId: zExt.objectId() }),
  output: z.object({}),
};
